import {
  TreatmentOnGoingTabButton,
  TreatmentOnGoingTabListIndicatorLine,
} from 'components/atoms';
import { TreatmentConsultationTab } from 'components/organisms/TreatmentConsultation/TreatmentConsultationTab';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useTreatmentOnGoing } from 'context';
import React from 'react';

import { TabContext } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import { PetInformationsModal } from '../PetInformationsModal';
import { PetRiskClassificationModal } from '../PetRiskClassificationModal';
import { TutorLocationModal } from '../TutorLocationModal';
import { PetHistoricTab } from 'components/organisms/petHistoric';
import { PetFilesModal } from '../PetFilesModal';

const TABS = ['Consultas' /*  'Histórico' */];

export const TreatmentOnGoingTabs: React.FC = () => {
  const [selected, setSelected] = React.useState('0');
  const { tutorLocationModal, petInformationsModal, riskClassificationModal, petFilesModal } =
    useTreatmentOnGoing();

  const handleChange = (index: string) => () => {
    setSelected(index);

    tutorLocationModal.onClose();
    petInformationsModal.onClose();
    riskClassificationModal.onClose();
    petFilesModal.onClose();
  };

  return (
    <Box mt={2}>
      <TabContext value={selected}>
        <Box position="relative">
          <Stack
            spacing={{ md: 6, sm: 2, xs: 1 }}
            direction="row"
            ml={{ md: 10, sm: 4, xs: 0 }}
          >
            {TABS.map((item, index) => (
              <TreatmentOnGoingTabButton
                key={item}
                selected={selected === String(index)}
                onClick={handleChange(String(index))}
              >
                {item}
              </TreatmentOnGoingTabButton>
            ))}
          </Stack>
          <TreatmentOnGoingTabListIndicatorLine />
        </Box>

        <PaperCardTemplate
          sx={{
            minHeight: 400,
            position: 'relative',
            overflow: 'visible',
            display: 'flex',
            mb: 8,
          }}
          childrenProps={{
            flex: 1,
            display: 'flex',
            p: 6,
            overflow: 'auto',
          }}
        >
          <TreatmentConsultationTab visible={selected === '0'} />
          {/* <PetHistoricTab visible={selected === '1'} /> */}

          <PetRiskClassificationModal />
          <PetInformationsModal />
          <PetFilesModal />
          <TutorLocationModal />
        </PaperCardTemplate>
      </TabContext>
    </Box>
  );
};
